import { render } from "./AsideMenu.vue?vue&type=template&id=128973c0"
import script from "./AsideMenu.vue?vue&type=script&lang=js"
export * from "./AsideMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__